import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { CanvasNode } from "@opus-dt/shared-types";

interface SensorScaleFormProps {
  node: CanvasNode;
  onChange: (next: Partial<CanvasNode>) => void;
}

export function SensorScaleForm({ node, onChange }: SensorScaleFormProps) {
  return (
    <div className="space-y-1.5">
      <Label htmlFor="sensor-id">ID do sensor (opcional)</Label>
      <Input
        id="sensor-id"
        placeholder="UUID do sensor"
        value={(node.data?.sensorId as string) ?? ""}
        onChange={(e) => onChange({ data: { ...node.data, sensorId: e.target.value } })}
      />
      {node.type === "SCALE" ? (
        <div className="mt-2 space-y-1.5">
          <Label htmlFor="unit">Unidade</Label>
          <Input
            id="unit"
            placeholder="kg, l, …"
            value={(node.data?.unit as string) ?? ""}
            onChange={(e) => onChange({ data: { ...node.data, unit: e.target.value } })}
          />
        </div>
      ) : null}
    </div>
  );
}
